
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { userAnalysisService } from "@/api/payments/user-analysis";
import { UserCountDto } from "@/api/service-proxies";

@Component({})
export default class StaticsCount extends Vue {
  @Prop({ type: String, default: "all" }) sourceType!: string;

  platformType: number | undefined = undefined;

  userCount: UserCountDto = null;

  created() {
    this.fetchData();
  }

  @Watch("sourceType")
  watchSourceType(newVal: string) {
    if (newVal == "all") this.platformType = undefined;
    else if ((newVal = "wechat")) this.platformType = 2;
    else if (newVal == "alipay") this.platformType = 3;

    this.fetchData();
  }

  async fetchData() {
    this.userCount = await userAnalysisService.getUserCount(this.platformType);
  }
}
